import { Box, Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import { Field, Form, Formik } from "formik";
import { useDispatch, useSelector } from "../../store";
import * as Yup from "yup";
import { editUser } from "../../slices/user";
import { Inputs } from "../formInputs";
import { Base } from "../base";
import User from "../../types/user";

interface Props {
  user?: User;
  close: () => void;
  onSave: () => void;
}

const AddEditUserForm: React.FC<Props> = (props) => {
  const { close, onSave, user } = props;
  const dispatch = useDispatch();
  const { status, user: dbUser } = useSelector((store) => store.user);
  const { jobTypes } = useSelector((store) => store.jobType);
  const theme = useTheme();

  const handleSubmit = (values: any) => {
    dispatch(editUser(values)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        updateAfterChanged();
      }
    });
  };

  const updateAfterChanged = () => {
    close();
    onSave();
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    email: Yup.string().email("Must be a valid email").required("Required"),
    // role: Yup.string().required("Required"),
  });

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        width: { sm: 600, xs: 300 },
        borderRadius: "10px",
        padding: "15px",
      }}
    >
      <Formik
        initialValues={{ ...user, assignedJobTypes: dbUser.assignedJobTypes }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize
      >
        <Form noValidate>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <Typography align="center">{`Edit ${user?.firstName} ${user?.lastName}`}</Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Field
                component={Inputs.Dropdown}
                multiple
                name="assignedJobTypes"
                options={jobTypes.map((jt) => {
                  return { ...jt, id: jt.id, value: jt.name };
                })}
                // TODO: Change name when we actually settle on what we're renaming these to
                label="Assigned Job Types"
                staticFilter
              />
            </Grid>
          </Grid>
          <Grid container direction={"row"} justifyContent={"space-between"}>
            <Grid>
              <Base.Button text="Cancel" type="secondary" onClick={close} />
            </Grid>
            <Grid>
              <Inputs.Submit
                isSubmitting={status === "loading"}
                text={"Save"}
              />
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </Box>
  );
};

export default AddEditUserForm;
